import { Style } from "@is/types";

export enum LocalStorageKeys {
  TenantId = "tenantId",
  DeviceId = "deviceId",
  StoreId = "storeId",
  ScannerDetails = "scannerDetails",
  SessionId = "sessionId",
  FinishedSessionId = "finishedSessionId",
  QRCheckoutSessionId = "qrCheckoutSessionId",
  StartUrl = "startUrl",
  LanguageCode = "i18nextLng",
  SearchId = "searchId",
  Version = "version",
  LastUpdateAt = "lastUpdateAt",
  Reload = "reload",
  CountryCode = "countryCode",
  TrackEvents = "trackEvents",
  CheckoutInfo = "checkoutInfo",
  CheckoutErrorMessage = "checkoutErrorMessage",
  PhoneCountryCode = "phoneCountryCode",
  BackgroundMedia = "backgroundMedia",
  BootJournal = "bootJournal",
  AppSessionHeartbeat = "appSessionHeartbeat",
  AppSessionLiveness = "appSessionLiveness",
}

export enum InstoreHttpHeaderNames {
  StoreId = "store-id",
  DeviceId = "device-id",
  SessionId = "session-id",
  TenantId = "tenant-id",
}

export const SEARCH_INPUT_DELAY = 1000;

export enum MediaOrientation {
  Horizontal = "horizontal",
  Vertical = "vertical",
}

export const DESKTOP_BREAKPOINT = 800;

export const SCREEN_BREAKPOINTS = {
  BIG_SCREEN_LANDSCAPE: 1680,
  MEDIUM_SCREEN_LANDSCAPE: 1300,
  SMALL_SCREEN_LANDSCAPE: 800,
};

export const SEARCH_DRAWER_WIDTH = {
  BIG_SCREEN_LANDSCAPE: 840,
  MEDIUM_SCREEN_LANDSCAPE: 650,
  SMALL_SCREEN_LANDSCAPE: 522,
};

export const STYLE_LEVEL_ATTRIBUTES: Partial<Record<keyof Style, string>> = {
  brand: "Brand",
  gender: "Gender",
};
